import styled from "styled-components";

export const StyledSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding: 0 65px;
    margin: 0 auto;
    max-width: 1280px;
  }
`;

export const StyledSectionWrapper = styled.div`
  border-bottom: 1px solid rgba(156, 163, 173, 0.24);
`;

export const StyledTitle = styled.div`
  padding: 32px 6% 0px 8%;
  margin-bottom: 56px;
  
  & > p {
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.161738px;
  }
  
  & > h3 {
    font-weight: bold;
    font-size: 29px;
    line-height: 40px;
    margin-top: 17px;
    color: #233247;
  }
  
  & span {
    color: #15ef81;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    & > h3 {
      font-size: 56px;
      line-height: 58px;
    }
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    max-width: 880px;
    padding: 70px 0 0 0;
  }
`;

export const StyledDescriptions = styled.div`
  padding: 0 6% 0 8%;

  & > p {
    margin-bottom: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #233247;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    width: 50%;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding: 0;
    max-width: 380px;
    margin-right: 30px;
  }
`;

export const StyledImagesWrapper = styled.div`
  position: relative;
  padding: 0 6% 0 8%;
  margin: 0 auto 10px;
  
  & > img {
    width: 100%;
    height: auto;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    width: 50%;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding: 0;
    margin: 0 0 0 auto;
    width: 55%;
    max-width: 565px;
  }
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  
  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    flex-direction: row;
    align-items: center;
  }
`;
